<script>
import rules from '@constants/Rules'

export default {
  props: {
    data: {
      type: Object,
      default: () => {},
      required: true,
    },
    message: {
      type: String,
      default: null,
    },
    _id: {
      type: String,
      default: null,
    },
    blacklist: {
      type: Array,
      default: () => {
        return []
      },
    },
    idKey: {
      type: String,
      default: 'id_cadastro_cliente',
    },
    actions: {
      type: Array,
      default: () => {
        return []
      },
      /**
       * text
       * action
       */
    },
    canEdit: Boolean,
    allRequired: Boolean,
    duplicateds: {
      type: Array,
      default: () => [],
    },
    duplicatedFields: {
      type: Array,
      default: () => {
        return []
      },
    },
    columnOrder: {
      type: Array,
      default: () => {
        return []
      },
    },
    widthTable: {
      type: String,
      default: 'max-content',
    },
  },
  data() {
    return {
      rules,
    }
  },
  computed: {
    columns() {
      if (!this.data) {
        return []
      }
      let aux = Object.values(this.data)[0]
      if (!aux) {
        return []
      }

      const retorno = Object.keys(aux).filter((a) => {
        return !this.blacklist.includes(a)
      })

      if (this.columnOrder.length) {
        return retorno.sort((a, b) => {
          return this.columnOrder.indexOf(a) - this.columnOrder.indexOf(b)
        })
      } else {
        return retorno
      }
    },
    rows() {
      return Object.values(this.data || {})
    },
  },
  methods: {
    orderColumnsRows(row) {
      if (!row) return []
      if (this.columnOrder.length) {
        const aux = Object.entries(row).filter((a) => {
          return !this.blacklist.includes(a[0])
        })

        aux.sort((a, b) => {
          return this.columnOrder.indexOf(a[0]) - this.columnOrder.indexOf(b[0])
        })

        return aux
      } else {
        return Object.entries(row).filter((a) => {
          return !this.blacklist.includes(a[0])
        })
      }
    },
    translateColumns(c) {
      const aux = {
        codigo_xp: 'Código XP',
        email: 'E-mail',
        nome: 'Nome',
        perfil: 'Perfil',
        pl_potencial: 'P/L Potencial',
        profissao: 'Profissao',
      }
      return aux[c] || c
    },
    isDuplicated(obj) {
      if (this.duplicateds && this.duplicateds.length) {
        return this.duplicateds.some((a) => {
          return this.compareObjects(a, obj)
        })
      }
      return false
    },
    compareObjects(a, b) {
      const keys1 = Object.keys(a).filter((k) => {
        return k !== 'index'
      })
      const keys2 = Object.keys(b).filter((k) => {
        return k !== 'index'
      })

      if (keys1.length !== keys2.length) {
        return false
      }

      for (let key of keys1) {
        if (this.duplicatedFields.length) {
          if (
            a[key] !== b[key].data_parsed &&
            this.duplicatedFields.includes(key)
          ) {
            return false
          }
        } else {
          if (a[key] !== b[key].data_parsed) {
            return false
          }
        }
      }

      return true
    },
  },
}
</script>

<template>
  <div>
    <span v-if="message" class="text-danger">
      {{ message }}
    </span>
    <v-simple-table
      :id="_id"
      style="margin-bottom: 10px"
      :style="{ width: widthTable }"
    >
      <template v-slot>
        <thead>
          <tr>
            <th
              v-for="(c, ind) in columns"
              :key="'headers-' + ind"
              class="text-left"
            >
              {{ c }}
            </th>
            <th v-for="i in actions.length" :key="'header-' + i"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(r, index) in rows"
            :key="'linha-' + index"
            :class="{
              'bg-danger': isDuplicated(r),
            }"
          >
            <td
              v-for="(d, iColumn) in orderColumnsRows(r)"
              :key="'coluna-' + iColumn"
              :class="d[1] ? d[1].html_classes : ''"
              :style="d[1] ? d[1].html_style : ''"
            >
              <div v-if="d[1] && d[1].data_ok">
                <span v-if="!canEdit"> {{ d[1].data_parsed }} </span>
                <v-text-field
                  v-if="canEdit"
                  v-model="d[1].data_parsed"
                  hide-details
                  class="mb-2 pt-0"
                  dense
                  :placeholder="d[0] + allRequired ? '*' : ''"
                  :required="allRequired"
                  :rules="allRequired ? [rules.required] : null"
                />
              </div>
              <v-tooltip v-if="d[1] && !d[1].data_ok" bottom>
                <template v-slot:activator="{ on }">
                  <div
                    style="
                      height: 100%;
                      width: 100%;
                      justify-content: center;
                      align-items: center;
                      display: flex;
                    "
                    v-on="on"
                  >
                    <span v-if="!canEdit" v-on="on">
                      {{ d[1].data_parsed || ' ' }}
                    </span>
                    <v-text-field
                      v-if="canEdit"
                      v-model="d[1].data_parsed"
                      v-on="on"
                    />
                  </div>
                </template>
                <span>{{ d[1].html_message }}</span>
              </v-tooltip>
            </td>
            <td>
              <BaseButton
                v-for="(a, i) in actions"
                :key="'acao-' + i"
                primary
                small
                @click="a.action(r[idKey], r)"
              >
                {{ a.title }}
              </BaseButton>
            </td>
            <small
              v-if="isDuplicated(r)"
              style="position: absolute; left: 30px; font-size: 10px"
            >
              Registro duplicado
            </small>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
